import React from 'react';
interface TermeniProps {
  navigate: (page: string) => void;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-4353">
      <h2 className="text-lg font-semibold text-light-1 mb-3" data-id="element-4354">{title}</h2>
      <div className="space-y-3" data-id="element-4355">{children}</div>
    </section>;
}
export function Termeni({
  navigate
}: TermeniProps) {
  return <div className="min-h-screen bg-dark-1" data-id="element-4356">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-4357">
        <h1 className="text-3xl sm:text-4xl font-bold text-light-1 mb-2" data-id="element-4358">
          Termeni si conditii
        </h1>
        <p className="text-sm text-light-4 mb-12" data-id="element-4359">
          Ultima actualizare: 29 martie 2026
        </p>

        <div className="space-y-10 text-light-2 text-sm leading-relaxed" data-id="element-4360">
          <Section title="1. Introducere" data-id="element-4361">
            <p data-id="element-4362">
              Bine ati venit pe Izio (&quot;Platforma&quot;), proiect operat de
              echipa Izio (&quot;Izio&quot;, &quot;noi&quot;,
              &quot;nostru&quot;).
            </p>
            <p data-id="element-4363">
              Acesti termeni si conditii (&quot;Termenii&quot;) guverneaza
              accesul si utilizarea platformei Izio, disponibila la adresa
              izio.ro. Prin crearea unui cont sau utilizarea Platformei,
              acceptati acesti Termeni in integralitate.
            </p>
            <p className="text-light-3 border border-dark-4 rounded-lg px-4 py-3 bg-dark-2/50" data-id="element-4364">
              <strong className="text-light-2" data-id="element-4365">Nota:</strong> Platforma Izio se
              afla in prezent intr-o faza de testare si validare (beta).
              Functionalitatile, continutul si acesti Termeni pot fi modificate
              pe masura ce serviciul evolueaza.
            </p>
          </Section>

          <Section title="2. Descrierea serviciului" data-id="element-4366">
            <p data-id="element-4367">
              Izio este o platforma online{' '}
              <strong className="text-light-1" data-id="element-4368">gratuita</strong> care
              faciliteaza conectarea chiriasilor cu proprietarii de imobile in
              vederea inchirierii de locuinte. Platforma permite:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-4369">
              <li data-id="element-4370">
                Chiriasilor sa isi creeze profile cu preferintele si
                informatiile relevante
              </li>
              <li data-id="element-4371">
                Proprietarilor sa consulte profilurile chiriasilor disponibile
              </li>
              <li data-id="element-4372">
                Chiriasilor sa aplice la anunturi externe, transmitand datele de
                contact ale proprietarului
              </li>
            </ul>
            <p data-id="element-4373">
              Izio{' '}
              <strong className="text-light-1" data-id="element-4374">
                nu percepe niciun comision sau taxa
              </strong>{' '}
              utilizatorilor sai si nu este parte in niciun contract de
              inchiriere intre chiriasi si proprietari. Izio nu garanteaza
              calitatea, legalitatea sau disponibilitatea locuintelor sau a
              chiriasilor.
            </p>
          </Section>

          <Section title="3. Eligibilitate si cont" data-id="element-4375">
            <p data-id="element-4376">
              Pentru a utiliza Platforma, trebuie sa aveti cel putin 18 ani si
              capacitate juridica deplina. La crearea contului, va obligati sa
              furnizati informatii corecte, complete si actualizate.
            </p>
            <p data-id="element-4377">
              Sunteti responsabil/a pentru confidentialitatea credentialelor
              contului dvs. si pentru toate activitatile desfasurate prin
              intermediul contului.
            </p>
          </Section>

          <Section title="4. Datele furnizate de utilizatori" data-id="element-4378">
            <p data-id="element-4379">
              Prin crearea unui profil de chirias, furnizati in mod voluntar
              informatii despre dvs. si preferintele dvs. de locuinta. Aceste
              informatii sunt afisate public pe Platforma pentru a fi vizibile
              proprietarilor.
            </p>
            <p data-id="element-4380">
              <strong className="text-light-1" data-id="element-4381">Nu colectam</strong> copii ale
              actelor de identitate, date bancare, date medicale sau orice alte
              date sensibile in sensul Art. 9 GDPR. Informatiile pe care le
              furnizati sunt exclusiv cele pe care le completati voluntar in
              formularul de creare profil.
            </p>
            <p data-id="element-4382">
              Aveti dreptul de a va face profilul privat sau de a va sterge
              contul in orice moment din setarile contului sau prin contactarea
              noastra la contact@izio.ro.
            </p>
          </Section>

          <Section title="5. Obligatiile utilizatorilor" data-id="element-4383">
            <p data-id="element-4384">Va angajati sa:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-4385">
              <li data-id="element-4386">Furnizati informatii reale si corecte in profilul dvs.</li>
              <li data-id="element-4387">Nu creati profile false sau inselatoare</li>
              <li data-id="element-4388">
                Nu utilizati Platforma pentru activitati ilegale sau frauduloase
              </li>
              <li data-id="element-4389">Nu hartuiti, abuzati sau discriminati alti utilizatori</li>
              <li data-id="element-4390">
                Nu extrageti date de pe Platforma prin mijloace automate
                (scraping)
              </li>
              <li data-id="element-4391">
                Respectati drepturile de proprietate intelectuala ale Izio si
                ale altor utilizatori
              </li>
            </ul>
          </Section>

          <Section title="6. Continutul utilizatorilor" data-id="element-4392">
            <p data-id="element-4393">
              Prin incarcarea de continut pe Platforma (texte, fotografie de
              profil, informatii de profil), acordati Izio o licenta
              neexclusiva, gratuita de a utiliza si afisa acest continut
              exclusiv in scopul furnizarii serviciului.
            </p>
            <p data-id="element-4394">
              Izio isi rezerva dreptul de a elimina orice continut care incalca
              acesti Termeni, legislatia in vigoare sau drepturile tertilor,
              fara notificare prealabila.
            </p>
          </Section>

          <Section title="7. Proprietate intelectuala" data-id="element-4395">
            <p data-id="element-4396">
              Platforma Izio, inclusiv designul, logo-ul, textele, grafica si
              software-ul, sunt proprietatea Izio si sunt protejate de
              legislatia privind drepturile de autor si proprietatea
              intelectuala.
            </p>
            <p data-id="element-4397">
              Nu aveti dreptul de a reproduce, modifica, distribui sau exploata
              comercial nicio parte a Platformei fara acordul scris prealabil al
              Izio.
            </p>
          </Section>

          <Section title="8. Limitarea raspunderii" data-id="element-4398">
            <p data-id="element-4399">
              Izio furnizeaza Platforma &quot;ca atare&quot; (&quot;as is&quot;)
              si nu ofera garantii explicite sau implicite privind:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-4400">
              <li data-id="element-4401">
                Calitatea sau fiabilitatea chiriasilor sau proprietarilor de pe
                Platforma
              </li>
              <li data-id="element-4402">Exactitatea informatiilor furnizate de utilizatori</li>
              <li data-id="element-4403">Disponibilitatea neintrerupta a Platformei</li>
              <li data-id="element-4404">Rezultatul interactiunilor dintre utilizatori</li>
            </ul>
            <p data-id="element-4405">
              In limita maxima permisa de lege, Izio nu va fi raspunzator/a
              pentru daunele directe, indirecte, incidentale sau consecvente
              rezultate din utilizarea Platformei.
            </p>
          </Section>

          <Section title="9. Suspendarea si inchiderea contului" data-id="element-4406">
            <p data-id="element-4407">
              Izio isi rezerva dreptul de a suspenda sau inchide contul dvs. in
              urmatoarele situatii:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-4408">
              <li data-id="element-4409">Incalcarea acestor Termeni</li>
              <li data-id="element-4410">Furnizarea de informatii false sau inselatoare</li>
              <li data-id="element-4411">Comportament abuziv fata de alti utilizatori</li>
              <li data-id="element-4412">Activitati suspectate a fi frauduloase</li>
            </ul>
            <p data-id="element-4413">
              Puteti solicita inchiderea contului in orice moment prin
              contactarea noastra la contact@izio.ro.
            </p>
          </Section>

          <Section title="10. Modificarea Termenilor" data-id="element-4414">
            <p data-id="element-4415">
              Izio isi rezerva dreptul de a modifica acesti Termeni in orice
              moment. Modificarile vor fi comunicate prin email sau prin
              notificare pe Platforma inainte de intrarea in vigoare.
              Continuarea utilizarii Platformei dupa intrarea in vigoare a
              modificarilor constituie acceptarea noilor Termeni.
            </p>
          </Section>

          <Section title="11. Legea aplicabila si jurisdictia" data-id="element-4416">
            <p data-id="element-4417">
              Acesti Termeni sunt guvernati de legislatia din Romania. Orice
              litigiu va fi solutionat de instantele competente din Romania.
            </p>
          </Section>

          <Section title="12. Contact" data-id="element-4418">
            <p data-id="element-4419">
              Pentru orice intrebari legate de acesti Termeni, ne puteti
              contacta la:
            </p>
            <ul className="list-none space-y-1" data-id="element-4420">
              <li data-id="element-4421">Email: contact@izio.ro</li>
            </ul>
          </Section>
        </div>
      </div>
    </div>;
}